import React, { useRef, useEffect, useState } from 'react';

const Input = ({
  label,
  type = 'text',
  id,
  name,
  value,
  onChange,
  placeholder,
  error,
  required = false,
  className = '',
  ...props
}) => {
  const textareaRef = useRef(null);
  const inputRef = useRef(null);
  const spanRef = useRef(null);
  const [inputWidth, setInputWidth] = useState(40); // default min width

  // Auto-expand textarea height
  useEffect(() => {
    if (type === 'textarea' && textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  }, [value, type]);

  // Auto-expand input width for expandable-text
  useEffect(() => {
    if (type === 'expandable-text' && spanRef.current && inputRef.current) {
      // Add some extra space (20px) for caret
      setInputWidth(spanRef.current.offsetWidth + 20);
    }
  }, [value, type]);

  return (
    <div className="mb-4">
      {label && (
        <label 
          htmlFor={id} 
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      {type === 'textarea' ? (
        <textarea
          ref={textareaRef}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`input-field resize-none overflow-hidden ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`}
          required={required}
          rows={1}
          {...props}
        />
      ) : type === 'expandable-text' ? (
        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
          <input
            ref={inputRef}
            type="text"
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={`input-field ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`}
            required={required}
            style={{ width: inputWidth, minWidth: 40, maxWidth: '100%' }}
            {...props}
          />
          {/* Hidden span to measure text width */}
          <span
            ref={spanRef}
            style={{
              position: 'absolute',
              visibility: 'hidden',
              height: 0,
              overflow: 'scroll',
              whiteSpace: 'pre',
              fontSize: inputRef.current ? window.getComputedStyle(inputRef.current).fontSize : undefined,
              fontFamily: inputRef.current ? window.getComputedStyle(inputRef.current).fontFamily : undefined,
              fontWeight: inputRef.current ? window.getComputedStyle(inputRef.current).fontWeight : undefined,
              padding: inputRef.current ? window.getComputedStyle(inputRef.current).padding : undefined,
              border: inputRef.current ? window.getComputedStyle(inputRef.current).border : undefined,
            }}
          >
            {value || placeholder || ''}
          </span>
        </div>
      ) : (
        <input
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`input-field ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`}
          required={required}
          {...props}
        />
      )}
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default Input; 